import script from "./Installperpo.vue?vue&type=script&setup=true&lang=js"
export * from "./Installperpo.vue?vue&type=script&setup=true&lang=js"

import "./Installperpo.vue?vue&type=style&index=0&id=33dc11f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dc11f8"]])

export default __exports__